import React from "react";

import { cn } from "../../../common/u1/cn";
import { Input } from "../../../common/u1/Input";
import { FieldLabel } from "../../../common/u1/FieldLabel";
import PhoneNumberInput from "../../../common/PhoneNumberInput";
import { PhoneCountrySelect } from "../../../common/u1/PhoneCountrySelect";
import { DESIGNATION_MAX_LENGTH } from "../../../../utils/designation";
import { representativeDesignationError } from "./orderWebProfileFields";

/* "Can we contact a business representative?" Transcribed: the whole block is optional and only appears once the box is ticked, and what is typed becomes the... */
export const RepresentativeFields = ({
  acknowledged,
  onAcknowledgedChange,
  rep,
  setRepField,
  className = "",
}) => (
  <div className={className}>
    <label
      htmlFor="owp-acknowledge"
      className={cn(
        "flex cursor-pointer items-start gap-2.5 rounded-[12px] border",
        "border-[var(--line)] bg-[var(--field-inset)] px-4 py-3"
      )}
    >
      <input
        id="owp-acknowledge"
        type="checkbox"
        checked={acknowledged}
        onChange={(e) => onAcknowledgedChange(e.target.checked)}
        className="mt-[3px] h-4 w-4 shrink-0 accent-[var(--coral)]"
      />
      <span className="text-[13px] leading-[1.55] text-[var(--ink-2)] font-sans">
        Can we contact a business representative using your provided details to
        create a detailed report?
      </span>
    </label>

    {acknowledged && (
      <div className="mt-3.5 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <Input
          label="Name"
          labelVariant="field"
          id="owp-rep-name"
          placeholder="Enter Name"
          value={rep.name}
          onChange={(e) => setRepField("name", e.target.value)}
        />
        <Input
          label="Designation"
          labelVariant="field"
          id="owp-rep-designation"
          placeholder="Enter Designation"
          maxLength={DESIGNATION_MAX_LENGTH}
          value={rep.designation}
          onChange={(e) => setRepField("designation", e.target.value)}
          error={representativeDesignationError(rep.designation)}
        />
        <Input
          label="Email"
          labelVariant="field"
          id="owp-rep-email"
          type="email"
          placeholder="Enter email"
          value={rep.email}
          onChange={(e) => setRepField("email", e.target.value)}
        />
        <div>
          <FieldLabel htmlFor="owp-rep-phone" variant="field">
            Phone
          </FieldLabel>
          <PhoneNumberInput
            id="owp-rep-phone"
            phone={rep.contactNumber}
            setPhone={(value) => setRepField("contactNumber", value || "")}
            verifyPhoneNumber={false}
            border
            countrySelect={PhoneCountrySelect}
            defaultCountry="AE"
          />
        </div>
      </div>
    )}
  </div>
);

export default RepresentativeFields;
